import { getLogger } from "@goodgamestudios/logger";

import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2TournamentRebuyDialog } from "../../../view/dialogs/tournament/Poker2TournamentRebuyDialog";
import { Poker2TournamentRebuyDialogProperties } from "../../../view/dialogs/tournament/Poker2TournamentRebuyDialogProperties";
import { Poker2LayoutManager } from "../../../view/Poker2LayoutManager";
import { Poker2Command } from "../Poker2Command";

const logger = getLogger("JRBCommand");

export class JRBCommand extends Poker2Command {
    protected get cmdId(): string {
        return "jrb";
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);

            switch (paramObj.state) {
                case 0:

                    if (Poker2LayoutManager.getInstance().currentState != 10) {
                        logger.error("Don't show rebuy dialog, player is not on table, currentState: " + Poker2LayoutManager.getInstance().currentState);
                        break;
                    }

                    //
                    this.layoutManager.showDialog("Poker2TournamentRebuyDialog", new Poker2TournamentRebuyDialogProperties(paramObj.jid, paramObj.jname, paramObj.chips, paramObj.gold));
                    break;

                case 1:

                    //
                    logger.info("JRBCommand S2C_REBUY_IN -> confirmation: rebuy successful");
                    break;

                default:
                    logger.error("Unkown status id: " + paramObj.state);
                    break;
            }

            return true;
        }
        else
            return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
